
import Vue from 'vue'
import Vuex from 'vuex'
import axios from "../plugins/axios";
import api from "../api";

Vue.use(Vuex)

var refreshToken = sessionStorage.getItem("refreshToken");
var accessToken = sessionStorage.getItem("accessToken");

var payload = JSON.parse(atob(accessToken?.split('.')[1] || '') || "{}");
var scope = payload?.scope || [];

console.log(payload);

export default new Vuex.Store({
    state: {
        refreshToken,
        accessToken,
        payload,
        // scope: JSON.parse(sessionStorage.getItem('scope') || '[]'),
        scope,
        worker: null,
        test: null,
        
        _carts: JSON.parse(sessionStorage.getItem("_carts") || '[]'), // 장바구니 상품
        _pickups: JSON.parse(sessionStorage.getItem("_pickups") || '[]'), // 주문 픽업상품

        agreements: JSON.parse(sessionStorage.getItem("agreements") || '[]'),
    },
    mutations: {
        agreements(state, agreements){
            state.agreements = agreements;

            sessionStorage.setItem("agreements", JSON.stringify(agreements));
        },
        login(state, { refreshToken, accessToken  }) {
            state.refreshToken = refreshToken;
            state.accessToken = accessToken;
            
            state.payload = JSON.parse(atob(accessToken?.split('.')[1] || '') || "{}");
            state.scope = state.payload?.scope || [];

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

            sessionStorage.setItem("refreshToken", refreshToken);
            sessionStorage.setItem('accessToken', accessToken);
        },

        setWorker(state, { worker }){
            state.worker = worker;

            // const scope = worker?.scope.length ? worker?.scope : state?.payload?.scope;

            // state.scope = scope
            // sessionStorage.setItem('scope', JSON.stringify(scope));
        },

        logout(state) {
            state.refreshToken = undefined;
            state.accessToken = undefined;
            state.worker = [];

            state.payload = {};
            state.scope = [];

            axios.defaults.headers.common['Authorization'] = '';

            sessionStorage.removeItem("refreshToken");
            sessionStorage.removeItem("accessToken");
        },

        addToCart(state, _carts){
            state._carts = _carts;
            sessionStorage.setItem("_carts", JSON.stringify(_carts));
        },

        checkout(state, _pickups){
            state._pickups = _pickups;
            sessionStorage.setItem("_pickups", JSON.stringify(_pickups));
        },
        test(state, test){
            state.test = test;
        }
    },
    actions: {
        test({ commit }, test ){
            commit("test", test);

        },
        agreements({ commit }, _terms){
            commit("agreements", _terms);
        },

        async login({ commit }, { username, password, _certification }){
            var { refreshToken } = await api.auth.getRefreshToken({ username, password, _certification });
            var { accessToken } = await api.auth.getAccessToken(refreshToken);

            commit("login", { refreshToken, accessToken } );
        },

        async setWorker({ commit }, { phone }){
            const { me } = await api.console.me.get();
            const worker = ((me?.workers || []).filter((person) =>person?.phone === phone))?.[0];

            commit("setWorker", { worker });
        },

        logout({ commit }) {
            commit("logout");
        },

        async refresh({ commit }, refreshToken){
            var { accessToken } = await api.auth.getAccessToken(refreshToken);

            commit("login", { refreshToken, accessToken });
        },

        addToCart({ commit }, _carts){
            commit("addToCart", _carts);
        },

        checkout({ commit }, _pickups){
            commit("checkout", _pickups);
        }
    },
    modules: {
    },
    getters: {
        hasViewerScope: state => {
            return (state?.scope || []).includes("viewer");
        }
    }
})
